import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../Actions/DocActions';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import CardFiltresFolders from './CardFiltresFolders';
import CardDocument from './CardDocument';
import CardDocumentLigne from './CardDocumentLigne';

function GenererFiltre(filtre, valeur) {
    return !filtre || filtre === valeur;
}

const AlertePasDeDoc = () => (
    <div className="jumbotron text-center">
        <h1 className="display-4">Vous n&apos;avez pas de documents.</h1>
    </div>
);

const AlerteTropDeFiltres = ({ docFiltresSuppression }) => (
    <div className="jumbotron text-center">
        <h1 className="display-4">Aucun document trouvé.</h1>
        <button type="button" className="btn btn-secondary btn-lg mt-3" onClick={() => docFiltresSuppression()}>
        <i class="fas fa-arrow-left" /> Retour à la liste complète
        </button>
    </div>
);

const MesDocs = ({ Filtres, Docs, actions }) => {
    if (!Docs || Docs.length === 0) return <AlertePasDeDoc />;

    /* On applique tous les filtres en une seule fois
    Les documents qui sont contenus dans le Store ne sont pas altérés
    GenererFiltre() renvoie toujours VRAI si le filtre n'est pas défini */
    const docsFiltreObjet = Docs.filter(doc => doc.Objet.toUpperCase().includes(Filtres.Objet.toUpperCase()));
    const docsFiltrer = docsFiltreObjet.filter(doc => GenererFiltre(Filtres.Prest, doc.Prest) && GenererFiltre(Filtres.Act, doc.Act));

    /* On affiche uniquement les documents filtrés */
    const listeDocsFiltrer = docsFiltrer.map((doc, i) => <CardDocumentLigne key={i} Doc={doc} actions={actions} />);

    return (
        <React.Fragment>
            <div className="row">
                <CardFiltresFolders docs={docsFiltreObjet} filtres={Filtres} actions={actions} />
            </div>
            {docsFiltrer.length === 0 ? (
                <AlerteTropDeFiltres docFiltresSuppression={actions.docFiltresSuppression} />
            ) : (
                <div className="row">{listeDocsFiltrer}</div>
            )}
        </React.Fragment>
    );
};
MesDocs.displayName = 'MesDocs';
MesDocs.requiredProps = [
    'Docs', // Liste des documents
    'Filtres', // Liste des filtres
];

function mapStateToProps({ DocStore: { Filtres, Docs } }) {
    return { Filtres, Docs };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(Actions, dispatch) };
}

export default connect(mapStateToPropsWrapper(mapStateToProps), mapDispatchToProps)(verificationProps(MesDocs));



// WEBPACK FOOTER //
// ./src/components/MesDocs/index.js